<template>
  <div>
    <div class="card">
      <div class="card-header" aria-label="Bank Details Header">
        <h3 class="card-title">
          {{ $t("users") }}
        </h3>
      </div>
      <div class="card-body" aria-label="Bank Details Body">
        <div class="d-flex align-items-center">
          <span
            style="cursor: pointer"
            @click="$refs.userFormModal.show()"
            class="font-weight-medium text-primary"
          >
            <feather-icon :icon="'PlusIcon'" size="12" />
            {{ $t("addUsers") }}
          </span>
        </div>
        <div class="table-responsive mt-3" v-if="usersList.length">
          <table class="vgt-table striped">
            <thead>
              <tr>
                <th>{{ $t("firstName") }}</th>
                <th>{{ $t("lastName") }}</th>
                <th>{{ $t("email") }}</th>
                <th class="text-center" v-if="usersList.length > 1">
                  {{ $t("actions") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(user, index) in usersList" :key="index">
                <td>{{ user.first_name }}</td>
                <td>{{ user.last_name }}</td>
                <td>{{ user.mail }}</td>
                <td v-if="usersList.length > 1" class="text-center">
                  <feather-icon
                    icon="Trash2Icon"
                    class="cursor-pointer text-danger"
                    size="18"
                    @click="deleteUser(index)"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="d-flex align-items-center gap-1 mt-1">
          <feather-icon
            icon="InfoIcon"
            class="text-danger"
            size="12"
            style="margin-left: 5px; margin-bottom: 4px"
          />
          <p class="text-danger">{{ $t("addAtLeastOneUser") }}</p>
        </div>
      </div>
    </div>
    <b-modal
      id="user-form-modal"
      size="lg"
      hide-footer
      title="Create User"
      ref="userFormModal"
      @hidden="resetForm"
      centered
    >
      <validation-observer ref="simpleRules">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-md-4">
                <div class="form-group">
                  <label class="input-label form-label"
                    >{{ $t("firstName") }}
                  </label>
                  <input
                    id="first_name"
                    v-model="form.first_name"
                    name="title"
                    class="form-control"
                    type="text"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="input-label form-label" for="cars">{{
                    $t("lastName")
                  }}</label>
                  <input
                    id="last_name"
                    v-model="form.last_name"
                    name="title"
                    class="form-control"
                    type="text"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="input-label form-label"
                    >{{ $t("email") }}&nbsp;<span style="color: red">*</span>
                  </label>
                  <validation-provider
                    #default="{ errors }"
                    name="Email"
                    rules="required"
                  >
                    <input
                      id="email"
                      v-model="form.mail"
                      name="title"
                      class="form-control"
                      type="text"
                      :class="{ 'is-invalid': errors[0] }"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-md-4">
                <div class="form-group">
                  <label class="input-label form-label" for="cars">{{
                    $t("city")
                  }}</label>
                  <input
                    id="title"
                    v-model="form.city"
                    name="title"
                    class="form-control"
                    type="text"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="input-label form-label" for="cars">{{
                    $t("street")
                  }}</label>

                  <input
                    id="street"
                    v-model="form.street"
                    name="street"
                    class="form-control"
                    type="text"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="input-label form-label" for="cars">{{
                    $t("streetNumber")
                  }}</label>
                  <input
                    id="street_number"
                    v-model="form.street_number"
                    name="street_number"
                    class="form-control"
                    type="text"
                  />
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-md-4">
                <div class="form-group">
                  <label class="input-label form-label" for="cars">{{
                    $t("zip")
                  }}</label>
                  <input
                    id="zip"
                    v-model="form.zip"
                    name="zip"
                    class="form-control"
                    type="text"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="input-label form-label" for="cars">{{
                    $t("mobile")
                  }}</label>
                  <input
                    id="mobile"
                    v-model="form.mobile"
                    name="mobile"
                    class="form-control"
                    type="text"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="input-label form-label" for="cars">{{
                    $t("phone")
                  }}</label>
                  <input
                    id="phone"
                    v-model="form.phone"
                    name="phone"
                    class="form-control"
                    type="text"
                  />
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-md-4">
                <div class="form-group">
                  <label class="input-label form-label" for="cars">{{
                    $t("roles")
                  }}</label>
                  <multiselect
                    v-model="form.roles"
                    label="title"
                    :multiple="true"
                    track-by="id"
                    :options="roles"
                    selectLabel=""
                    deselectLabel=""
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="input-label form-label" for="cars">{{
                    $t("types")
                  }}</label>
                  <multiselect
                    v-model="form.types"
                    :multiple="true"
                    :options="types"
                    selectLabel=""
                    deselectLabel=""
                  />
                </div>
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-md-4">
                <div class="d-flex align-items-center gap-1">
                  <div class="form-group w-100">
                    <label class="input-label form-label"
                      >{{ $t("password") }}&nbsp;<span style="color: red"
                        >*</span
                      >
                    </label>
                    <validation-provider
                      #default="{ errors }"
                      name="Password"
                      rules="required"
                    >
                      <b-input-group
                        class="input-group-merge"
                        :class="errors.length > 0 ? 'is-invalid' : null"
                      >
                        <b-form-input
                          id="new-password"
                          v-model="form.password"
                          :state="errors.length > 0 ? false : null"
                          class="form-control-merge"
                          :type="passwordFieldType"
                          autocomplete="new-password"
                          name="new-password"
                          placeholder="············"
                          :class="{ 'is-invalid': errors[0] }"
                        />
                        <b-input-group-append is-text>
                          <feather-icon
                            class="cursor-pointer"
                            :icon="passwordToggleIcon"
                            @click="togglePasswordVisibility"
                          />
                        </b-input-group-append>
                      </b-input-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </div>

                  <feather-icon
                    @click="generatePassword"
                    class="cursor-pointer mt-2"
                    icon="RefreshCwIcon"
                    size="16"
                  />
                </div>
                <ul class="list-unstyled text-muted medium mt-1">
                  <li :class="{ 'text-success': hasNumber }">
                    ✔ At least 1 numeric
                  </li>
                  <li :class="{ 'text-success': hasUppercase }">
                    ✔ At least one capital letter
                  </li>
                  <li :class="{ 'text-success': hasSpecialChar }">
                    ✔ At least one special character
                  </li>
                  <li :class="{ 'text-success': hasValidLength }">
                    ✔ 8 characters
                  </li>
                </ul>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="input-label form-label"
                      >{{ $t("confirmPassword") }}&nbsp;<span style="color: red"
                      >*</span
                    >
                  </label>
                  <validation-provider
                    #default="{ errors }"
                    name="Confirm Password"
                    rules="required"
                  >
                    <b-input-group
                      class="input-group-merge"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                    >
                      <b-form-input
                        id="new-password"
                        v-model="form.confirmPassword"
                        :state="errors.length > 0 ? false : null"
                        class="form-control-merge"
                        :type="passwordFieldType"
                        autocomplete="new-password"
                        name="new-password"
                        placeholder="············"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          class="cursor-pointer"
                          :icon="passwordToggleIcon"
                          @click="togglePasswordVisibility"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <!-- <input
                id="confirmPassword"
                v-model="form.confirmPassword"
                name="title"
                class="form-control"
                type="password"
              /> -->
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                  <div v-if="!passwordsMatch" style="color: red">
                    {{ $t("passwordAndConfirmPasswordShouldBeMatched") }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
      <div class="d-flex justify-content-end align-item-center">
        <button
          @click="$refs.userFormModal.hide()"
          class="btn btn-secondary mr-1 btn-md"
        >
          {{ $t("close") }}
        </button>
        <b-button
          @click="createUser()"
          class="cursor-pointer"
          :disabled="isFormInvalid"
        >
          <span class="align-middle">{{ $t("createUser") }}</span>
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import TextInput from "@/components/TextInput.vue";
import Multiselect from "vue-multiselect";
import { mapGetters } from "vuex";
import MultiSelectInput from "@/components/MultiSelectInput.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import formDirtyMixin from "@/mixins/formDirtyMixin";
export default {
  components: {
    TextInput,
    Multiselect,
    MultiSelectInput,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      openModal: false,
      submitted: false,
      usersList: [],
      form: {
        first_name: "",
        last_name: "",
        mail: "",
        city: "",
        street: "",
        street_number: "",
        zip: "",
        mobile: "",
        phone: "",
        roles: [],
        types: ["employee"],
        password: "",
        confirmPassword: "",
      },
      types: ["customer_employee", "employee", "partner"],
      passwordsMatch: true,
    };
  },
  computed: {
    ...mapGetters("roles", ["roles"]),
    hasNumber() {
      return /\d/.test(this.form.password);
    },
    hasUppercase() {
      return /[A-Z]/.test(this.form.password);
    },
    hasSpecialChar() {
      return /[^a-zA-Z0-9]/.test(this.form.password);
    },
    hasValidLength() {
      return this.form.password.length >= 8;
    },
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    isPasswordValid() {
      return (
        this.hasNumber &&
        this.hasUppercase &&
        this.hasSpecialChar &&
        this.hasValidLength
      );
    },
    isFormInvalid() {
      return (
        !this.form.mail ||
        !this.form.password ||
        !this.form.confirmPassword ||
        !this.isPasswordValid
      );
    },
  },
  async created() {
    try {
      await this.$store.dispatch("roles/list", {
        limit_start: 0,
        limit_count: 100,
      });
    } catch (e) {
      console.error("api error ___", e);
    }
  },

  methods: {
    async deleteUser(index) {
      const confirmed = await this.showConfirmationDialog({
        title: this.$t("doYouWantToDeleteThisRecord"),
        subText: this.$t("yesDeleteIt"),
      });

      if (confirmed) {
        this.usersList.splice(index, 1);
        this.$emit("usersListUpdated", this.usersList);
      }
    },
    generatePassword() {
      const numbers = "0123456789";
      const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const lowercase = "abcdefghijklmnopqrstuvwxyz";
      const specialChars = "!@#$%^&*()_+-=[]{}|;:,.<>?";
      const allChars = numbers + uppercase + lowercase + specialChars;

      // Ensure each requirement is met at least once
      let password = "";
      password += numbers[Math.floor(Math.random() * numbers.length)];
      password += uppercase[Math.floor(Math.random() * uppercase.length)];
      password += specialChars[Math.floor(Math.random() * specialChars.length)];

      // Fill remaining characters
      while (password.length < 8) {
        password += allChars[Math.floor(Math.random() * allChars.length)];
      }

      // Shuffle password characters for randomness
      password = password
        .split("")
        .sort(() => 0.5 - Math.random())
        .join("");

      // Set password to form model (assuming form.password is your v-model)
      this.form.password = password;
      this.form.confirmPassword = password;
    },
    async createUser() {
      try {
        this.$refs.simpleRules.validate().then(async (success) => {
          if (success) {
            this.passwordsMatch = true;
            this.submitted = true;
            if (!this.isPasswordValid) {
              return;
            }
            if (this.form.password !== this.form.confirmPassword) {
              this.passwordsMatch = false;
            } else {
              // this.$store.commit("showLoader", true);
              this.passwordsMatch = true;

              const newUser = {
                ...this.form,
                roles:
                  this.form.roles && this.form.roles.length
                    ? this.form.roles.map((role) => role.id)
                    : [],
              };

              this.usersList.push(newUser);
              // Emit to parent
              this.$emit("usersListUpdated", this.usersList);
              // Reset Form
              this.resetForm();

              // Close Modal
              this.$refs.userFormModal.hide();

              // const response = await this.$store.dispatch("users/create", {
              //   ...form,
              //   company_id: this.form.company_id?.id ?? "",
              //   set_company_id: this.form.company_id?.id ?? "",
              //   roles:
              //     this.form.roles && this.form.roles.length
              //       ? this.form.roles.map((role) => role.id)
              //       : [],
              // });
            }
          }
        });
      } catch (e) {
        console.error("api error ___", e);
      }
    },
    resetForm() {
      this.form = {
        first_name: "",
        last_name: "",
        mail: "",
        city: "",
        street: "",
        street_number: "",
        zip: "",
        mobile: "",
        phone: "",
        roles: [],
        types: ["employee"],
        password: "",
        confirmPassword: "",
      };
      this.passwordsMatch = true;
    },
  },
};
</script>

<style>
#nprogress {
  position: relative;
  z-index: 9999999;
}

.white-color {
  color: white !important;
}

.vgt-responsive {
  overflow-x: visible !important;
}
/* #user-form-modal {
  display: flex !important;
  justify-content: center;
  align-items: center;
} */
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
